module.exports = __webpack_public_path__ + "static/media/dentist.cfb779b4.svg";